export class StudentDocumentsFilter {
	fileName = '';
	description = '';
	documentType = '';
	for = '';
	fileType = '';
	createdFrom: Date = undefined;
	createdTo: Date = undefined;
	addedBy = '';
}